import { BackgroundMedia } from "./components/BackgroundMedia";
import { HeroSection } from "./components/HeroSection";
import { ProjectsSection } from "./components/ProjectsSection";
import { WorkSection } from "./components/WorkSection";
import { projects } from "./config/site";
import { SiteFooter } from "./components/SiteFooter";
import { SiteHeader } from "./components/SiteHeader";
import { useBackgroundMedia } from "./hooks/useBackgroundMedia";
import { useSmoothScroll } from "./hooks/useSmoothScroll";

function App() {
  const media = useBackgroundMedia();
  useSmoothScroll();

  return (
    <div
      className="relative isolate min-h-svh overflow-clip bg-surface text-ink"
      itemScope
      itemType="https://schema.org/Person"
    >
      <a className="skip-link" href="#content">
        Skip to content
      </a>
      <BackgroundMedia
        enabled={media.enabled}
        videoRef={media.videoRef}
        state={media.state}
        isMuted={media.isMuted}
        onReady={media.markReady}
        onUnavailable={media.markUnavailable}
      />
      <SiteHeader media={media} />
      <main id="content" tabIndex={-1}>
        <HeroSection />
        <div className="bg-surface/90">
          <WorkSection />
          <ProjectsSection projects={projects} />
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}

export default App;
